<template>
  <div class="main">
    <!-- 阴影 -->
    <!-- <img class="shadow" src="@/assets/mobile/image/common/shadow.png" /> -->
    <!-- 标签栏 -->
    <div class="label-boxs">
      <div
        :class="['label', { 'label-active': item === active }]"
        v-for="item in list"
        :key="item"
        @click="active = item"
      >
        {{ item }}

        <span v-if="item === active"></span>
      </div>
    </div>
    <!-- 卡片列表 -->
    <div class="task-list" v-if="active === '推荐问卷'">
      <div
        class="task-item"
        v-for="(item, index) in list1"
        :key="index"
        @click="goUrl(item.encryptId)"
      >
        <div class="task-left">
          <img class="edit" src="@/assets/mobile/image/home/edit.png" />
          <div class="text-box">
            <div class="text-top">{{ item.title }}</div>
            <div class="img-bottom">
              <img
                class="star"
                v-for="cItem in Math.floor(item.IR / 20)"
                :key="cItem"
                src="@/assets/mobile/image/home/star-s.png"
              />
              <img
                class="star"
                v-for="cItem in 5 - Math.floor(item.IR / 20)"
                :key="cItem + Math.floor(item.IR / 20) + 1"
                src="@/assets/mobile/image/home/star-k.png"
              />
            </div>
          </div>
        </div>
        <div class="task-right">
          <div class="shang">
            <img
              v-if="item.deviceType === 2 || item.deviceType === 1"
              src="@/assets/image/homepage/pc.png"
            />
            <img
              v-if="item.deviceType === 1 || item.deviceType === 3"
              src="@/assets/image/homepage/phone.png"
            />
          </div>
          <div class="number-box">
            <span class="number">{{ item.minPoints }}~{{ item.maxPoints }}</span
            >金币
          </div>
        </div>
      </div>

      <div class="empty-box" v-if="list1.length === 0">
        <el-empty description="暂无数据"></el-empty>
      </div>
    </div>

    <div class="task-list" v-if="active === '话题讨论'">
      <div
        class="task-item"
        v-for="(item, index) in list2"
        :key="index"
        @click="goUrl2(item.surveyLink)"
      >
        <div class="task-left">
          <img class="edit" src="@/assets/mobile/image/home/edit.png" />
          <div class="text-box">
            <div class="text-top">{{ item.title }}</div>
            <div class="img-bottom">
              <img
                class="star"
                v-for="cItem in Math.floor(item.IR / 20)"
                :key="cItem"
                src="@/assets/mobile/image/home/star-s.png"
              />
              <img
                class="star"
                v-for="cItem in 5 - Math.floor(item.IR / 20)"
                :key="cItem + Math.floor(item.IR / 20) + 1"
                src="@/assets/mobile/image/home/star-k.png"
              />
            </div>
          </div>
        </div>
        <div class="task-right">
          <div class="shang">
            <img
              v-if="item.deviceType === 2 || item.deviceType === 1"
              src="@/assets/image/homepage/pc.png"
            />
            <img
              v-if="item.deviceType === 1 || item.deviceType === 3"
              src="@/assets/image/homepage/phone.png"
            />
          </div>
          <div class="number-box">
            <span class="number">{{ item.minPoints }}~{{ item.maxPoints }}</span
            >金币
          </div>
        </div>
      </div>
      <div class="empty-box" v-if="list2.length === 0">
        <el-empty description="暂无数据"></el-empty>
      </div>
    </div>

    <Tabbar :active="2"></Tabbar>
  </div>
</template>

<script>
import {
  getIndividualSurveys,
  getForumSurveys,
  getAccount,
  getWeChatAuthWechatUrl,
} from "@/api/mobile";
import { generateUUID } from "@/utils/replace";
import Tabbar from "@/components/tabbar.vue";
export default {
  data() {
    return {
      active: "推荐问卷",
      list: ["推荐问卷", "话题讨论"],
      list1: [],
      list2: [],
      weixinFlag: false,
    };
  },
  components: { Tabbar },
  methods: {
    //获取任务列表
    async getIndividualSurveys() {
      await getIndividualSurveys().then((res) => {
        if (res.code === 200) {
          console.log("res", res);
          this.list1 = res.data.list;
        }
      });
    },

    async getForumSurveys() {
      await getForumSurveys().then((res) => {
        if (res.code === 200) {
          console.log("res", res);
          this.list2 = res.data.list;
        }
      });
    },
    goUrl(id) {
      this.$router.push(`/mobile/taskDetails?id=${id}`);
    },
    goUrl2(path) {
      location.href = path;
    },
  },
  async created() {
    //微信自动登录
    if (this.$route.query.from && this.$route.query.from === "wechat") {
      this.weixinFlag = true;
      let state = generateUUID();
      let redirectUrl =
        "https://www.aidajuan.com/mobile/landingPage?url=" + "/mobile/task";
      await getWeChatAuthWechatUrl({
        redirectUrl,
        state,
      }).then((res) => {
        if (res.code === 200) {
          window.location.href = res.data;
        }
      });
    }
    if (this.weixinFlag) {
      return;
    }
    await this.getIndividualSurveys();
    await this.getForumSurveys();
  },
};
</script>

<style lang="scss" scoped>
.main {
  background-color: #f8f8f8;
  padding-bottom: 50px;
  min-height: calc(100vh - 50px);
  position: relative;
  //阴影
  .shadow {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 1;
  }
  //标签栏
  .label-boxs {
    display: flex;
    align-items: center;
    background-color: #f8f8f8;
    top: 0;
    height: 50px;
    padding: 0 15px;
    position: fixed;
    z-index: 999;
    width: 100%;
    .label {
      margin-right: 23px;
      flex-shrink: 0;
      font-size: 16px;
      color: #232323;
      font-weight: bolder;
      position: relative;
      span {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        display: block;
        width: 19px;
        height: 4px;
        background: #8846ff;
        border-radius: 10px 10px 10px 10px;
        bottom: -8px;
      }
    }
    .label-active {
      font-size: 22px;
      color: #8846ff;
    }
  }
  //卡片列表
  .task-list {
    padding: 60px 15px 0 15px;
    .task-item {
      width: 100%;
      height: 82px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      .task-left {
        padding-left: 10px;
        display: flex;
        .edit {
          width: 46px;
          height: 46px;
          margin-top: 15px;
        }
      }
      .text-box {
        margin-left: 18px;
        .text-top {
          font-size: 16px;
          color: #232323;
          font-weight: bolder;
          margin-top: 13px;
          span {
            margin-right: 10px;
          }
        }
        .img-bottom {
          display: flex;
          margin-top: 15px;
          .star {
            width: 16px;
            height: 16px;
            margin-right: 3px;
          }
        }
      }
      .task-right {
        margin-right: 10px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        .shang {
          display: flex;
          img {
            width: 14px;
            height: 14px;
            margin-top: 15px;
            margin-left: 5px;
          }
        }
        .number-box {
          color: #232323;
          font-size: 12px;
          margin-top: 13px;
          .number {
            font-size: 20px;
            color: #ff6017;
            font-weight: bolder;
            margin-right: 5px;
          }
        }
      }
    }
  }
}
.empty-box {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>